<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12 class="text-xs-center" mt-5>
        <h1>Vpis</h1>
        <p>Še nimaš računa? <router-link to="register">Registriraj se</router-link>.</p>
      </v-flex>
      <v-flex xs12 sm6 offset-sm3 mt-3>
        <form @submit.prevent="login">
          <v-layout column>
            <v-flex>
              <v-text-field
                name="email"
                label="Email"
                id="email"
                type="email"
                v-model="email"
                required></v-text-field>
            </v-flex>
            <v-flex>
              <v-text-field
                name="password"
                label="Password"
                id="password"
                type="password"
                v-model="password"
                required></v-text-field>
            </v-flex>
            <p class="text-xs-center">
              <router-link to="reset-password">Pozabljeno geslo</router-link>
            </p>
            <v-flex class="text-xs-center" mt-5>
              <v-btn
                color="primary"
                type="submit"
                @click="login">
                Vpiši se
              </v-btn>
            </v-flex>
          </v-layout>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import firebase from 'firebase';

export default {
  name: 'login',
  data() {
    return {
      email: '',
      password: '',
    };
  },

  methods: {
    login() {
      // console.log(firebase, this.email, this.password);

      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(
          (user) => {
            console.log(user);
            this.$router.go({ path: this.$router.path });
          },
          (err) => {
            console.log(err.message);
          },
        );
    },
  },
};
</script>
